import { render, staticRenderFns } from "./SkyShowFeiShuSheetView.vue?vue&type=template&id=1c4cb95d&scoped=true"
import script from "./SkyShowFeiShuSheetView.vue?vue&type=script&lang=js"
export * from "./SkyShowFeiShuSheetView.vue?vue&type=script&lang=js"
import style0 from "./SkyShowFeiShuSheetView.vue?vue&type=style&index=0&id=1c4cb95d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cb95d",
  null
  
)

export default component.exports